import PropTypes from "prop-types";
import * as React from "react";
import { Typography } from "../../themeV2";
import css from "./ShopInfo.module.css";

export default function AttentionList({ items }) {
  return (
    <ul className={css.attentionList}>
      {items.map(({ id, label, count }) => (
        <li className={css.attentionItem} key={id}>
          <span className={css.attentionCount} aria-hidden={count === null}>
            {count === null ? "!" : count}
          </span>
          <Typography variant="label-lg" as="span">
            {label}
          </Typography>
        </li>
      ))}
    </ul>
  );
}

AttentionList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      count: PropTypes.number,
    }),
  ).isRequired,
};
